"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ModalButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _excluded = ["modalTitle", "modalBody", "modalFooter", "children", "getToggle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ModalButton(_ref) {
  var modalTitle = _ref.modalTitle,
    modalBody = _ref.modalBody,
    modalFooter = _ref.modalFooter,
    children = _ref.children,
    getToggle = _ref.getToggle,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var toggleModal = function toggleModal() {
    return setModalOpen(!modalOpen);
  };
  if (getToggle) {
    getToggle(toggleModal);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    isOpen: modalOpen,
    toggle: toggleModal
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
    tag: "h4",
    toggle: toggleModal
  }, modalTitle), modalBody && /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, _.isFunction(modalBody) ? modalBody({
    toggleModal: toggleModal
  }) : modalBody), modalFooter && /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, null, modalFooter)), /*#__PURE__*/_react["default"].createElement(_reactstrap.Button, (0, _extends2["default"])({}, rest, {
    onClick: toggleModal,
    type: "button"
  }), children));
}